import { Root } from './sticky-buttons.styled'
import { cx } from '@emotion/css'

const StickyButtons = ({ className, show, children }) => {
	return (
		<Root className={cx('StickyButtons-root', className)} show={show}>
			{children}
		</Root>
	)
}

export default StickyButtons
